module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5OTAiIGhlaWdodD0iNjMwIiB2aWV3Qm94PSIwIDAgMzMgMjEiPjxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0wIDBoMzN2MjFIMHoiLz48cGF0aCBkPSJNMCAwaDMzdjE0SDB6Ii8+PHBhdGggZmlsbD0iIzAwNzJjZSIgZD0iTTAgMGgzM3Y3SDB6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/est.svg
// module id = eE3/
// module chunks = 0